export default __webpack_public_path__ + "static/media/the-neighbourhood.915d7677.jpg";